import React from 'react'
import { Query } from 'react-apollo'
import validateRedirectUriQuery from 'graphs/queries/ValidateRedirectUri.graphql'

const ValidateRedirectUri = ({ children, redirectUri }) => (
  <Query variables={{ uri: redirectUri }} query={validateRedirectUriQuery}>
    {({ loading, data: { validate_redirect_uri } }) =>
      loading ? null : children(validate_redirect_uri)
    }
  </Query>
)

export default ValidateRedirectUri



// WEBPACK FOOTER //
// ./src/components/AuthenticatedRedirect/ValidateRedirectUri.js